<template>
	<v-dialog
		v-if="exibirModal"
		v-model="exibirModal"
		:scrollable="!$vuetify.breakpoint.smAndDown"
		persistent
		:max-width="maxWidth"
		:fullscreen="$vuetify.breakpoint.smAndDown"
	>
		<v-card tile>
			<slot name="title">
				<v-card-title class="justify-center primary py-2 text-center text-subtitle-1 white--text">
					<span class="font-weight-bold" :class="{ 'texto-titulo': $vuetify.breakpoint.mobile }">{{
						titulo
					}}</span>
					<v-spacer></v-spacer>
					<v-icon
						id="closeModal"
						:class="{ 'close-modal-mobile': $vuetify.breakpoint.mobile }"
						dark
						@click="$emit('close')"
					>
						mdi-close
					</v-icon>
				</v-card-title>
			</slot>

			<v-card-text class="corpo-modal">
				<slot name="body"></slot>
			</v-card-text>
			<v-divider></v-divider>
			<slot v-if="customActions" name="actions"></slot>
			<v-card-actions v-else class="bg-white my-2 py-2">
				<botao-cancelar-confirmar
					:nome-botao-cancelar="nomeBotaoCancelar"
					:acao-confirmar="acaoConfirmar"
					:acao-cancelar="acaoCancelar"
					:nome-botao-confirmar="nomeBotaoConfirmar"
					:cor-do-botao-confirmar="corDoBotaoConfirmar"
					:is-confirmar-visivel="isConfirmarVisivel"
					:is-confirmar-desabilitado="isConfirmarDesabilitado"
				></botao-cancelar-confirmar>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import BotaoCancelarConfirmar from '@/views/components/BotaoCancelarConfirmar.vue'

export default {
	name: 'modal',
	components: { BotaoCancelarConfirmar },
	props: {
		exibir: {
			type: Boolean,
		},
		titulo: {
			type: String,
			default: '',
		},
		maxWidth: {
			type: [Number, String],
			default: 1000,
		},
		customActions: {
			type: Boolean,
			default: true,
		},
		acaoCancelar: {
			type: Function,
			default: () => {
				alert('Ação de cancelar não implementada')
			},
		},
		acaoConfirmar: {
			type: Function,
			default: () => {
				alert('Ação de confirmar não implementada')
			},
		},
		nomeBotaoConfirmar: {
			type: String,
			default: 'Confirmar',
		},
		nomeBotaoCancelar: {
			type: String,
			default: 'CANCELAR',
		},
		corDoBotaoConfirmar: {
			type: String,
			default: 'primary',
		},
		isConfirmarVisivel: {
			type: Boolean,
		},
		isConfirmarDesabilitado: {
			type: Boolean,
		},
		scrollable: {
			type: Boolean,
		},
	},
	emits: ['close'],
	computed: {
		exibirModal() {
			return this.exibir
		},
	},
}
</script>

<style lang="stylus">
.corpo-modal
	box-sizing border-box !important

.ajustar_altura_do_modal_com_historico {
	height: 67vh;
}
</style>
